import { VATs } from "../../../redux/settingsSlice";
import store from "../../../redux/store";
import { jobsFinalSum, jobsFinalVat, sumWithVAT, vatString } from "../TableSums";

export default function buildJobsTips(jobs, showComplexity) {
    const jobsVat = store.getState().settings.vats[VATs.jobs];
    const showVat = jobsVat.active;

    const body = [];

    const createJobText = (job) => {
        if(!job.repair_tips) return;
        const operationName = job.operation.operation_name !== '' ? ' - ' + job.operation.operation_name : '';
        const jobNote = job.other ? " (" + job.other + ")" : "";

        return job.detail.part_name + operationName + jobNote;
    };

    jobs.forEach((job) => {
        if(!job.repair_tips) return;
        if (!job.detail.detailOnly) {
            const row = [
                {
                    text: createJobText(job),
                }
            ].filter(Boolean);
            body.push(row);
        }
    });
    if(body.length){
        body.unshift([
            {
                text: 'Наименование работы',
                bold: true
            }
        ].filter(Boolean))

        const widths = ['*'].filter(Boolean);
        return [
            {
                text: 'Рекомендуемые работы',
                alignment: 'center',
                style: 'subheader'
            },
            {
                layout: 'lightHorizontalLines',
                table: {
                    headerRows: 1,
                    widths: widths,
                    body: body
                }
            }
        ];
    }
    return null;

}